module.exports = __webpack_public_path__ + "static/media/2.70d15f7a.jpg";